import { Component, ElementRef, Inject, ViewChild } from '@angular/core';
import { BaseComponent } from '@lib/components';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { IAuthResponse, IError, IUser } from '@lib/interfaces';
import { ITransferResponse } from '@lib/interfaces/transfer.interface';
import { exportElementToPdf, maskFullName } from '@lib/utils';

@Component({
    template: '',
})
export class SharedPeerToPeerSuccessComponent extends BaseComponent {
    recipientInfo: IUser; // receiver's info
    userInfo: IAuthResponse['admin']; // sender info
    transferResponse: ITransferResponse;
    errorDetails: IError;
    isMoneySent: boolean;

    @ViewChild('pdfExport', { static: false }) pdfTable: ElementRef;

    constructor(public dialogRef: MatDialogRef<SharedPeerToPeerSuccessComponent>, @Inject(MAT_DIALOG_DATA) public data: { moneySent: boolean }) {
        super();
    }

    protected handleDownloadPdf() {
        exportElementToPdf(this.pdfTable.nativeElement, 'send-money.pdf');
    }

    protected retryFundsTransfer() {
        this.dialogRef.close();
    }

    // NEOIQ-2427: shared with the Top-up for Agent flow via @lib/utils — see the same getter on
    // SharedPeerToPeerComponent for why this replaces the inline masking expression.
    get maskedRecipientName(): string {
        return maskFullName(this.recipientInfo?.first_name, this.recipientInfo?.last_name);
    }
}
